export default {
  username: 'getter:username',
  email: 'getter:email',
  carrier: 'getter:carrier',
  bankAccountQuantity: 'getter:bankAccountQuantity',
  providersQuantity: 'getter:providersQuantity',
  account: 'getter:account.productType',
  lastName: 'getter:lastName',
  firstName: 'getter:firstName',
  notificationQuantity: 'getter:notificationQuantity',
  beneficiariesQuantity: 'getter:beneficiariesQuantity',
  groupLocalPhone: 'getter:groupLocalPhone',
  groupTollFreePhone: 'getter(phone):groupTollFreePhone',
  groupTollFreePhoneNoFormat: 'getter:groupTollFreePhone',
  groupSupportEmail: 'getter:groupEmail',
  groupHours: 'getter:groupHours',
  groupLocalFax: 'getter:groupLocalFax',
  groupTollFreeFax: 'getter:groupTollFreeFax',
  memberID: 'getter:memberId',
  groupID: 'getter:groupID',
  groupBrandName: 'getter:groupBrandName',
  groupMainSiteURL: 'getter:groupMainSiteURL',
};
